import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default function BucketIcon(props) {
  return (
    <SvgIcon viewBox='0 0 70 70' {...props} >
      <path d="M63.95,15.786c0,4.006-12.963,7.238-28.949,7.238
					c-15.988,0-28.951-3.232-28.951-7.238l9.65,43.839c0,2.672,8.637,4.826,19.301,4.826c10.662,0,19.299-2.154,19.299-4.826l0,0
					L63.95,15.786z"/>
      <path d="M63.95,12.786c0-4.004-12.963-7.237-28.949-7.237
					c-15.988,0-28.951,3.233-28.951,7.237c0,4.006,12.963,7.238,28.951,7.238C50.987,20.024,63.95,16.792,63.95,12.786L63.95,12.786
					z"/>
    </SvgIcon>
  );
}

